// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   USER AVATAR COMPONENT
   ===================================================== */

.user-avatar-component {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  position: relative;
}

.user-avatar-component:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.avatar-initials {
  color: white;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  user-select: none;
  line-height: 1;
}

/* Variantes de contexto */
.clickable-container:hover .user-avatar-component {
  transform: scale(1.08);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
}`, "",{"version":3,"sources":["webpack://./common/components/UserAvatar/UserAvatar.css"],"names":[],"mappings":"AAAA;;0DAE0D;;AAE1D;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,0CAA0C;AAC5C","sourcesContent":["/* =====================================================\n   USER AVATAR COMPONENT\n   ===================================================== */\n\n.user-avatar-component {\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  overflow: hidden;\n  position: relative;\n}\n\n.user-avatar-component:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.avatar-initials {\n  color: white;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  user-select: none;\n  line-height: 1;\n}\n\n/* Variantes de contexto */\n.clickable-container:hover .user-avatar-component {\n  transform: scale(1.08);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
